import { Link, Typography } from "@material-ui/core";

import { SoilFLOOverrideToastProps } from "../../interface/SoilFLOOverrideToastProps";

/**
 * Error toast body shown when a SoilFLO ticket is received but SoilFLO has no load
 * for its BoL#. Shared by the main pit and every sub-stream dashboard. The number
 * never wraps apart from its label, and the override action sits beneath the message.
 */
const SoilFLOOverrideToast = ({
  ticketNumber,
  onOverride,
}: SoilFLOOverrideToastProps) => (
  <>
    <Typography>
      No SoilFLO load exists with BoL#:{" "}
      <b style={{ whiteSpace: "nowrap" }}>{ticketNumber}</b>
    </Typography>
    <Link
      component="button"
      onClick={onOverride}
      style={{ display: "block", marginTop: 6, fontWeight: 600 }}
    >
      Override?
    </Link>
  </>
);

export default SoilFLOOverrideToast;
